<template lang="pug">
  table
    tr(v-for="result in results")
      td {{result.modifiedOn|shortDate}}
      td {{result.score}}
      td {{getSeverity(result.severity) | snakeToCamelCase}}
</template>
<script>
import snakeToCamelCase from '@/filters/snakeToCamelCase.js';

export default {
  name: 'AssessmentScore',
  props: {
    results: {
      type: Array,
      required: true
    }
  },
  filters: {
    snakeToCamelCase
  },
  methods: {
    getSeverity(severity) {
      if (severity === 'EXTREMELYSEVERE') {
        return 'Extremely severe';
      }
      return severity;
    }
  }
};
</script>